import { Link } from "react-router-dom";
import { FaCheckCircle, FaTimes } from "react-icons/fa";
import styles from "./PricePlanComp.module.css";

export default function PricePlanComp({
  kicker = "Pricing Plans",
  title = "Simple pricing options for the services your business needs.",
  lead = "",
  plans = [],
  sectionClassName = "",
}) {
  return (
    <section className={`${styles.section} ${sectionClassName}`.trim()}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.header}>
          {kicker ? <span className={styles.kicker}>{kicker}</span> : null}
          <h2>{title}</h2>
          {lead ? <p className={styles.lead}>{lead}</p> : null}
        </div>

        <div className={styles.pricingGrid}>
          {plans.map((plan) => (
            <article
              key={plan.name}
              className={`${styles.card} ${plan.highlighted ? styles.cardFeatured : ""}`}
            >
              <div className={styles.cardTop}>
                <span className={styles.planName}>{plan.name}</span>
                <div className={styles.priceRow}>
                  <span className={styles.price}>{plan.price}</span>
                  {/* {plan.note ? (
                    <span className={styles.priceNote}>{plan.note}</span>
                  ) : null} */}
                </div>
                {plan.subnote ? (
                  <span className={styles.subnote}>{plan.subnote}</span>
                ) : null}
                {/* {plan.description ? (
                  <p className={styles.description}>{plan.description}</p>
                ) : null} */}
              </div>

              <div className={styles.features}>
                {plan.features.map((feature) => (
                  <div key={feature.label} className={styles.featureItem}>
                    <span
                      className={`${styles.featureIcon} ${
                        feature.included
                          ? styles.iconIncluded
                          : styles.iconExcluded
                      }`}
                    >
                      {feature.included ? <FaCheckCircle /> : <FaTimes />}
                    </span>
                    <span
                      className={`${styles.featureText} ${
                        !feature.included ? styles.featureTextMuted : ""
                      }`}
                    >
                      {feature.label}
                    </span>
                  </div>
                ))}
              </div>

              <Link
                to={plan.href || "/contact-us"}
                className={styles.planButton}
              >
                {plan.buttonLabel || "Select plan"}
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
